export default __webpack_public_path__ + "fonts/inter-latin-900-normal.e562b180fd59e87154b1.woff";